// extracted by mini-css-extract-plugin
export var button = "_k2-2";
export var card = "_k2-0";
export var closeButtonContainer = "_k2-3";
export var iconContainer = "_k2-1";